import { INTERNAL_COMPLAINT_PRODUCT_DESCRIPTION_MAX_LENGTH } from '@/constants'

const messages = {
    menuTitle: 'Jakość',

    certificateApprovals: {
        pageTitle: 'Aprobaty FSC/PEFC',
        menuTitle: 'Aprobaty FSC/PEFC',

        headers: {
            id: 'L.p.',
            transferredAt: 'Data',
            jobNumber: 'Numer zlecenia produkcyjnego',
            trader: 'Handlowiec',
            jobName: 'Nazwa pracy',
            actions: 'Akcje'
        },

        missingTrader: 'brak',

        filters: {
            dateFrom: 'Data od',
            dateTo: 'Data do',
            certificateType: 'Rodzaj certyfikatu',
            certificateAll: 'Wszystkie',
            trader: 'Handlowiec',
            traderNoData: 'Wpisz treść aby odnaleźć handlowca.',
            searchingTrader: 'Trwa wyszukiwanie...',
            jobNumber: 'Numer zlecenia'
        },

        actions: {
            details: 'Szczegóły',
            delete: 'Usuń'
        },

        detail: {
            pageTitle: 'Szczegóły aprobaty FSC/PEFC',
            backToList: 'Powrót do listy',
            inDevelopment: 'Sekcja w trakcie developmentu.',
            sections: {
                sales: 'Dział handlowy',
                supplyChain: 'Dział łańcucha dostaw',
                technology: 'Dział technologiczny',
                fscPefcRepresentative: 'Pełnomocnik ds. certyfikacji FSC/PEFC'
            },
            fields: {
                date: 'Data',
                jobNumber: 'Numer zlecenia',
                trader: 'Handlowiec',
                jobName: 'Nazwa pracy',
                approvalNumber: 'Numer aprobaty'
            },
            validation: {
                required: 'Numer aprobaty musi zawierać co najmniej jeden znak.',
                maxLength: 'Numer aprobaty może mieć maksymalnie {max} znaków.'
            },
            supplyChain: {
                date: 'Data',
                position: 'Pozycja {number}',
                addPosition: 'Dodaj pozycję',
                removePosition: 'Usuń pozycję',
                empty: 'Brak pozycji papierowych. Możesz dodać pozycję ręcznie.',
                fields: {
                    materialCategory: 'Kategoria materiału',
                    description: 'Opis',
                    financePaperName: 'Nazwa papieru',
                    invoiceNumber: 'Numer FV zakupu',
                    supplier: 'Dostawca',
                    receivedAmount: 'Otrzymana [ark]',
                    receivedWeight: 'Otrzymana [kg]'
                },
                validation: {
                    dateRequired: 'Data jest wymagana.'
                }
            }
        },

        errors: {
            fetchList: 'Pobranie listy aprobat FSC/PEFC nie powiodło się.',
            fetchDetail: 'Pobranie szczegółów aprobaty FSC/PEFC nie powiodło się.',
            save: 'Zapis aprobaty FSC/PEFC nie powiódł się.',
            fetchPapers: 'Pobranie listy papierów nie powiodło się.'
        },

        notifications: {
            saveSuccess: 'Aprobata FSC/PEFC została zapisana.'
        },

        sentry: {
            details: 'Szczegóły aprobaty FSC/PEFC',
            delete: 'Usuń aprobatę FSC/PEFC',
            cancel: 'Anuluj edycję aprobaty FSC/PEFC',
            save: 'Zapisz aprobatę FSC/PEFC',
            addPaperPosition: 'Dodaj pozycję papierową aprobaty FSC/PEFC',
            removePaperPosition: 'Usuń pozycję papierową aprobaty FSC/PEFC'
        }
    },

    qualitativeNotes: {
        pageTitle: 'Uwagi jakościowe',
        menuTitle: 'Uwagi jakościowe',

        dialog: {
            titleNew: 'Nowa uwaga jakościowa',
            titleView: 'Podgląd uwagi jakościowej {number}'
        },

        filters: {
            reportedByNoData: 'Wpisz treść aby odnaleźć zgłaszającego.',
            responsibleNoData: 'Wpisz treść aby odnaleźć osobę odpowiedzialną.',
            authorizedNoData: 'Wpisz treść aby odnaleźć osobę zatwierdzającą.',
            searchingUsers: 'Trwa wyszukiwanie...'
        },

        createDialog: {
            title: 'Tworzenie uwagi jakościowej'
        },

        headers: {
            number: 'Numer',
            productionProcess: 'Proces',
            code: 'Defekt',
            reportedBy: 'Zgłaszający',
            responsiblePeople: 'Osoba odpowiedzialna',
            authorizedBy: 'Zatwierdzający',
            createdAt: 'Data złożenia',
            actions: 'Akcje'
        },

        actions: {
            open: 'Otwórz',
            delete: 'Usuń',
            generateReport: 'Generuj raport',
            create: 'Dodaj uwagę jakościową'
        },

        fields: {
            reportedBy: 'Zgłaszający',
            productionProcess: 'Proces produkcyjny',
            code: 'Defekt',
            comment: 'Komentarz'
        },

        deleteDialog: {
            title: 'Usuwanie uwagi jakościowej',
            message: 'Czy na pewno chcesz usunąć uwagę jakościową?',
            confirmButton: 'Usuń'
        },

        reportItems: {
            title: 'Wyszukiwarka zleceń oraz zamówień',
            numberLabel: 'Numer',
            selectButton: 'Wybierz',
            headers: {
                number: 'Numer',
                type: 'Typ',
                plateNumber: 'Montaż',
                actions: 'Akcje'
            },
            ordersTitle: 'Powiązane zamówienia',
            ordersHeaders: {
                number: 'Numer',
                product: 'Produkt',
                amount: 'Nakład'
            },
            ordersRequired: 'Proszę wybrać co najmniej jedno zamówienie.'
        },

        validation: {
            reportedByRequired: 'Proszę wybrać zgłaszającego.',
            responsibleRequired: 'Proszę wybrać osobę odpowiedzialną.',
            responsibleMax: 'Maksymalnie 10 osób odpowiedzialnych.',
            productionProcessRequired: 'Proszę wybrać proces.',
            codeRequired: 'Proszę wybrać kod.',
            commentMax: 'Maksymalna długość komentarza to 60 znaków.'
        },

        errors: {
            fetchList: 'Pobranie listy uwag jakościowych nie powiodło się.',
            report: 'Wygenerowanie raportu uwag jakościowych nie powiodło się.',
            delete: 'Usunięcie uwagi jakościowej nie powiodło się.',
            create: 'Utworzenie uwagi jakościowej nie powiodło się.',
            fetchCodes: 'Pobranie kodów defektów nie powiodło się.',
            reportItemPlates: 'Pobranie zleceń oraz zamówień nie powiodło się.',
            reportItemPlateOrders: 'Pobranie zamówień nie powiodło się.'
        },

        notifications: {
            reportSuccess: 'Raport po wygenerowaniu zostanie wysłany na adres {email}.',
            deleteSuccess: 'Uwaga jakościowa została usunięta.',
            createSuccess: 'Uwaga jakościowa została utworzona.'
        },

        sentry: {
            create: 'Dodaj uwagę jakościową.',
            open: 'Otwórz uwagę jakościową.',
            delete: 'Usuń uwagę jakościową.',
            generateReport: 'Generuj raport uwag jakościowych.',
            selectReportItem: 'Wybierz raportowane zlecenie.',
            cancelCreateDialog: 'Anuluj tworzenie uwagi jakościowej.',
            saveCreateDialog: 'Zapisz uwagę jakościową.',
            closeViewDialog: 'Zamknij podgląd uwagi jakościowej.',
            closeReportItemsDialog: 'Zamknij wyszukiwarkę raportowanych zleceń'
        }
    },

    codeCompliance: {
        pageTitle: 'Kontrola kodów EAN',
        menuTitle: 'Kontrola kodów EAN',

        filters: {
            orderNumber: 'Numer zamówienia...'
        },

        table: {
            headers: {
                date: 'Data',
                operator: 'Operator',
                orderNumber: 'Numer zamówienia',
                code: 'Kod',
                compliantCodesSum: 'Zgodność kodu',
                nonCompliantCodesSum: 'Niezgodność kodu'
            }
        },

        actions: {
            generateReport: 'Generuj raport'
        },

        errors: {
            fetchList: 'Pobranie listy kontroli kodów EAN nie powiodło się.',
            report: 'Wygenerowanie raportu kontroli kodów EAN nie powiodło się.'
        },

        notifications: {
            reportSuccess: 'Raport po wygenerowaniu zostanie wysłany na adres {email}.'
        },

        sentry: {
            generateReport: 'Generuj raport kontroli kodów EAN.'
        }
    },

    stopCards: {
        pageTitle: 'Karty stop',
        menuTitle: 'Karty stop',

        actions: {
            open: 'Otwórz kartę stop',
            create: 'Dodaj kartę stop',
            close: 'Zamknij kartę stop',
            print: 'Drukuj kartę stop',
            generateReport: 'Generuj raport'
        },

        headers: {
            number: 'Numer',
            createdAt: 'Data wystawienia',
            jobNumber: 'Numer zlecenia',
            orderNumber: 'Numer zamówienia',
            productType: 'Produkt',
            error: 'Kod błędu',
            productionDepartment: 'Dział odpowiedzialny',
            productionProcess: 'Proces',
            createdBy: 'Osoba wystawiająca',
            status: 'Status',
            actions: 'Akcje'
        },

        filters: {
            createdByLabel: 'Osoba wystawiająca',
            statusLabel: 'Status',
            productionDepartmentLabel: 'Dział odpowiedzialny',
            searchLabel: 'Szukaj...',
            productionProcessLabel: 'Proces',
            errorLabel: 'Kod błędu',
            productTypeLabel: 'Produkt',
            createdAtFromLabel: 'Od:',
            createdAtToLabel: 'Do:',
            createdByNoData: 'Wpisz treść aby odnaleźć osobę wystawiającą.',
            noData: 'Brak danych...',
            searchingUsers: 'Trwa wyszukiwanie...'
        },

        sentry: {
            create: 'Dodaj kartę stop.',
            open: 'Otwórz kartę stop.',
            close: 'Zamknij kartę stop.',
            print: 'Drukuj kartę stop.',
            generateReport: 'Generuj raport kart stop.',
            internalComplaintDisabled: 'Utworzenie reklamacji wewnętrznej z karty stop jest tymczasowo niedostępne.'
        },

        errors: {
            fetchList: 'Pobranie listy kart stop nie powiodło się.',
            fetch: 'Pobranie danych karty stop nie powiodło się.',
            create: 'Dodanie karty stop nie powiodło się.',
            update: 'Aktualizacja karty stop nie powiodła się.',
            fetchErrors: 'Pobranie kodów błędów kart stop nie powiodło się.',
            fetchStatuses: 'Pobranie statusów kart stop nie powiodło się.',
            fetchWaysOfClosing: 'Pobranie słownika sposobów zamknięcia kart stop nie powiodło się.',
            fetchProductionDepartments: 'Pobranie działów dla kart stop nie powiodło się.',
            report: 'Wygenerowanie raportu kart stop nie powiodło się.',
            print: 'Drukowanie karty stop nie powiodło się.',
            noQualitativeNoteForStopCard: 'Brak uwag jakościowych dla karty stop.'
        },

        notifications: {
            createSuccess: 'Karta stop została dodana.',
            updateSuccess: 'Karta stop została zaktualizowana.',
            reportSuccess: 'Raport kart stop został wysłany na adres {email}.'
        },

        dialog: {
            titleNew: 'Tworzenie karty stop',
            titleView: 'Karta stop {number}',
            objectNumberLabel: 'Numer zlecenia lub zamówienia.',
            objectNumberHint: 'Wpisz lub zeskanuj numer zlecenia lub zamówienia.',
            objectNumberNoQuery: 'Wpisz treść aby odnaleźć zamówienie lub zlecenie.',
            objectNumberTooShort: 'Wpisz przynajmniej {min} znaki.',
            objectNumberSearching: 'Trwa wyszukiwanie zamówienia/zlecenia...',
            objectNumberNotFound: 'Nie odnaleziono zamówienia/zlecenia dla zapytania: {query}.',
            plateNumberLabel: 'Numer montażu',
            quantityLabel: 'Ilość wstrzymana',
            departmentLabel: 'Dział',
            productionSiteGroupLabel: 'Grupa stanowisk',
            processLabel: 'Proces produkcyjny',
            errorCodeGroupLabel: 'Grupa błędu',
            errorLabel: 'Kod błędu',
            productLabel: 'Produkt',
            descriptionLabel: 'Opis niezgodności'
        },

        printDialog: {
            title: 'Wybór ilości kopii',
            copiesLabel: 'Ilość kopii',
            cancel: 'Anuluj',
            confirm: 'Akceptuj'
        },

        closeDialog: {
            title: 'Zamykanie karty stop',
            message: 'Zamknięcie karty wiąże się z wystawieniem:',
            qualitativeNoteButton: 'Uwagi jakościowej',
            internalComplaintButton: 'Reklamacji wewnętrznej'
        },

        validation: {
            objectNumberRequired: 'Proszę wybrać numer zlecenia lub zamówienia.',
            plateNumberRequired: 'Proszę podać numer montażu.',
            quantityRequired: 'Proszę podać ilość wstrzymaną.',
            departmentRequired: 'Proszę wybrać dział.',
            productRequired: 'Proszę wybrać produkt.'
        }
    },

    complaints: {
        pageTitle: 'Reklamacje',
        menuTitle: 'Lista reklamacji',
        popup: {
            createTitle: 'Nowa reklamacja'
        },

        headers: {
            number: 'Numer reklamacji',
            type: 'Typ reklamacji',
            jobNumber: 'Numer zlecenia',
            orderNumbers: 'Numer zamówienia',
            status: 'Status',
            department: 'Dział',
            createdAt: 'Data złożenia',
            modifiedAt: 'Data ostatniej modyfikacji',
            creator: 'Zgłaszający',
            assigned: 'Rozpatrujący',
            customer: 'Klient',
            actions: 'Akcje'
        },

        filters: {
            typeLabel: 'Rodzaj',
            statusLabel: 'Status',
            departmentLabel: 'Dział',
            jobNumberLabel: 'Numer zlecenia',
            orderNumberLabel: 'Numer zamówienia',
            searchLabel: 'Szukaj...',
            creatorLabel: 'Zgłaszający',
            assignedLabel: 'Rozpatrujący',
            customerLabel: 'Klient',
            responsibleLabel: 'Osoby odpowiedzialne',
            createdAtFromLabel: 'Od:',
            createdAtToLabel: 'Do:',
            searchingUsers: 'Trwa wyszukiwanie...',
            jobNumberSearching: 'Trwa wyszukiwanie...',
            orderNumberSearching: 'Trwa wyszukiwanie...',
            creatorNoData: 'Wpisz treść aby odnaleźć zgłaszającego.',
            assignedNoData: 'Wpisz treść aby odnaleźć rozpatrującego.',
            responsibleNoData: 'Wpisz treść aby odnaleźć osobę odpowiedzialną.',
            jobNumberNoData: 'Nie znaleziono zlecenia o podanym numerze.',
            orderNumberNoData: 'Nie znaleziono zamówienia o podanym numerze.'
        },

        actions: {
            createExternal: 'Dodaj reklamację zewnętrzną',
            createInternal: 'Dodaj reklamację wewnętrzną',
            open: 'Otwórz',
            printCard: 'Drukuj kartę',
            copy: 'Kopiuj',
            history: 'Historia',
            delete: 'Usuń',
            save: 'Zapisz',
            backToList: 'Powrót do listy',
            transferToDkj: 'Przekaż do DKJ',
            confirm: 'Zapoznałem się',
            generateReport: 'Generuj raport',
            stopCards: 'Karty stop'
        },

        edit: {
            pageTitle: 'Reklamacja / Edycja reklamacji - {number}',
            printCard: 'Wydruk karty reklamacji',
            copy: 'Kopiowanie',
            history: 'Historia',
            delete: 'Usuń reklamację',
            stopCards: 'Karty stop'
        },

        details: {
            tabTitle: 'Szczegóły',
            typeLabel: 'Typ reklamacji',
            externalComplaintType: 'Reklamacja zewnętrzna',
            departmentLabel: 'Dział',
            subDepartmentLabel: 'Wydział',
            machineLabel: 'Maszyna',
            machineNoData: 'Nie znaleziono symbolu maszyny',
            orderNumbersLabel: 'Numer zamówienia',
            customerLabel: 'Klient',
            orderNumbersNoData: 'Nie znaleziono',
            orderNumbersSearchNoQuery: 'Wpisz treść aby odnaleźć zamówienie.',
            orderNumbersSearchTooShort: 'Wpisz przynajmniej {min} znaki.',
            orderNumbersSearchLoading: 'Trwa wyszukiwanie zamówień...',
            orderNumbersSearchNotFound: 'Nie odnaleziono zamówień na zapytanie: "{query}".',
            orderNumbersAddDialogTitle: 'Dodawanie numeru zamówienia',
            orderNumbersAddTooltip: 'Dodaj numer zamówienia',
            orderNotesDialogTitle: 'Uwagi jakościowe i reklamacje wewnętrzne',
            orderCostsLabel: 'Koszty zamówień',
            discrepancyCatcherLabel: 'Kto wyłapał błąd',
            discrepancyCatcherNoData: 'Wpisz treść aby odnaleźć osobę, która wyłapała błąd.',
            discrepancyCatcherNotFound: 'Nie znaleziono.',
            productDescriptionLabel: 'Opis reklamowanej części',
            discrepancyDescriptionLabel: 'Opis niezgodności / oczekiwania klienta',
            priorityLabel: 'Priorytet',
            scaleAmountLabel: 'Skala niezgodności',
            scaleAmountSuffix: 'szt.',
            scalePercentLabel: 'Skala niezgodności',
            scalePercentSuffix: '%',
            complaintCostLabel: 'Koszt reklamacji'
        },

        attachments: {
            tabTitle: 'Załączniki',
            fileLabel: 'Pliki',
            placeholder: 'Wybierz pliki',
            uploadButton: 'Dodaj',
            noData: 'Nie dodano załączników.',
            maxFileSizeInfo: 'Dopuszczalny rozmiar pojedynczego pliku: {size}MB',
            maxFileSizeError: 'Przekroczono dopuszczalny rozmiar pliku: {size}MB.',
            headers: {
                fileName: 'Nazwa pliku',
                actions: 'Akcje'
            },
            downloadTooltip: 'Pobierz',
            deleteTooltip: 'Usuń',
            deleteTitle: 'Usuwanie załącznika',
            deleteMessage: 'Czy na pewno chcesz usunąć załącznik: {fileName}?',
            deleteConfirmButton: 'Usuń'
        },

        causes: {
            tabTitle: 'Przyczyny',
            discrepancyCauseLabel: 'Przyczyna niezgodności',
            responsibleLabel: 'Osoby odpowiedzialne',
            responsibleNoData: 'Wpisz treść aby odnaleźć osobę odpowiedzialną.',
            errorLabel: 'Opis błędu',
            errorNoData: 'Nie znaleziono opisu błędu.',
            addErrorDialogTitle: 'Dodawanie nowego błędu',
            addErrorNameLabel: 'Nazwa błędu',
            addErrorNameRequired: 'Proszę podać nazwę błędu.',
            addErrorCancel: 'Anuluj',
            addErrorConfirm: 'Dodaj',
            addErrorTooltip: 'Dodaj nowy błąd',
            addErrorSuccess: 'Błąd został dodany.',
            addErrorError: 'Dodanie błędu nie powiodło się.'
        },

        commissions: {
            tabTitle: 'Zalecenia',
            correctiveMeasuresLabel: 'Środki korygujące niezgodność'
        },

        actionsTab: {
            tabTitle: 'Akcje',
            reprintLabel: 'Dodruk',
            existingTaskLabel: 'Z istniejącego zlecenia',
            newTaskLabel: 'W nowym zleceniu',
            jobNumberLabel: 'Numer zlecenia',
            plateNumberLabel: 'Numer montażu',
            amountLabel: 'Ilość',
            amountSuffix: 'szt.',
            searchNoQuery: 'Wpisz treść aby odnaleźć zlecenie.',
            searchTooShort: 'Wpisz przynajmniej {min} znaki.',
            searchLoading: 'Trwa wyszukiwanie zleceń...',
            searchNotFound: 'Nie odnaleziono zleceń na zapytanie: "{query}".'
        },

        commentsTab: {
            tabTitle: 'Komentarze'
        },

        comments: {
            empty: 'Brak komentarzy dla reklamacji.',
            addLabel: 'Dodaj komentarz',
            sendButton: 'Wyślij'
        },

        execution: {
            tabTitle: 'Wykonanie',
            headers: {
                orderNumber: 'Nr zamówienia',
                product: 'Produkt',
                actions: 'Akcje'
            },
            empty: 'Brak danych wykonania dla reklamacji.'
        },

        historyDialog: {
            title: 'Historia statusu',
            headers: {
                oldStatus: 'Status przed',
                newStatus: 'Status po',
                changer: 'Zmieniający',
                createdAt: 'Data utworzenia'
            },
            empty: 'Brak danych historii statusów.'
        },

        deleteDialog: {
            title: 'Usuwanie reklamacji',
            message: 'Czy na pewno chcesz usunąć reklamację?',
            confirmButton: 'Usuń'
        },

        removeReasonDialog: {
            title: 'Proszę wybrać powód usunięcia reklamacji.',
            label: 'Powód usunięcia',
            validation: 'Proszę wybrać powód.'
        },

        validation: {
            orderNumbersRequired: 'Numer zamówienia jest wymagany.',
            discrepancyDescriptionRequired: 'Opis niezgodności jest wymagany.',
            scaleAmountRequired: 'Skala niezgodności jest wymagana.',
            scaleAmountInteger: 'Proszę wpisać liczbę całkowitą.',
            scalePercentRequired: 'Skala niezgodności jest wymagana.',
            scalePercentInteger: 'Proszę wpisać liczbę całkowitą.',
            complaintCostFormat: 'Wpisz poprawną wartość z maksymalnie dwoma miejscami po przecinku.',
            complaintCostRange: 'Wartość musi mieścić się w zakresie od 0 do 999 999,99.',
            reprintTaskRequired: 'Jeden z typów dodruku jest wymagany.'
        },

        errors: {
            fetchList: 'Pobranie listy reklamacji nie powiodło się.',
            fetchComplaint: 'Pobranie danych reklamacji nie powiodło się.',
            report: 'Wygenerowanie raportu reklamacji nie powiodło się.',
            fetchTypes: 'Pobranie typów reklamacji nie powiodło się.',
            fetchStatuses: 'Pobranie statusów reklamacji nie powiodło się.',
            fetchProductionDepartments: 'Pobranie działów produkcyjnych nie powiodło się.',
            fetchErrors: 'Pobranie błędów nie powiodło się.',
            searchOrders: 'Szukanie zamówień nie powiodło się.',
            orderBelongsToOtherCustomer: 'Wybrano zamówienie należące do innego klienta',
            create: 'Utworzenie reklamacji nie powiodło się.',
            update: 'Aktualizacja reklamacji nie powiodła się.',
            createAttachment: 'Dodanie załącznika nie powiodło się.',
            deleteAttachment: 'Usunięcie załącznika nie powiodło się.',
            printComplaintCard: 'Wydruk karty reklamacji nie powiódł się.',
            fetchStatusHistory: 'Pobranie historii statusów nie powiodło się.',
            deleteComplaint: 'Usunięcie reklamacji nie powiodło się.'
        },

        notifications: {
            reportSuccess: 'Raport reklamacji po wygenerowaniu zostanie wysłany na adres {email}.',
            createSuccess: 'Reklamacja została dodana.',
            updateSuccess: 'Reklamacja została zaktualizowana.',
            deleteSuccess: 'Reklamacja została usunięta.',
            copyPlaceholder: 'TBD'
        },

        closeStopCardsDialog: {
            title: 'Zamykanie kart stop',
            message: 'Czy chcesz zamknąć powiązane karty stop?',
            confirmButton: 'Zamknij karty stop'
        },

        createdStopCardsDialog: {
            title: 'Karty stop',
            columnNumber: 'Numer',
            columnActions: 'Akcje',
            openAction: 'Otwórz',
            openTooltip: 'Otwórz',
            closeAction: 'Zamknij',
            closeButton: 'Zamknij'
        },

        transferToDkjDialog: {
            title: 'Potwierdzenie przekazania reklamacji do DKJ',
            message: 'Czy na pewno chcesz przekazać reklamację do DKJ?',
            confirmButton: 'Przekaż do DKJ'
        },

        confirmDialog: {
            title: 'Potwierdzenie zapoznania się z reklamacją',
            message: 'Czy na pewno chcesz potwierdzić?'
        },

        sentry: {
            createExternal: 'Dodaj reklamację zewnętrzną.',
            createInternal: 'Dodaj reklamację wewnętrzną.',
            open: 'Otwórz reklamację.',
            generateReport: 'Generuj raport reklamacji.',
            transferToDkj: 'Przekaż reklamację do DKJ.',
            confirm: 'Potwierdź zapoznanie się z reklamacją.',
            printCard: 'Drukuj kartę reklamacji.',
            history: 'Pokaż historię statusów reklamacji.',
            delete: 'Usuń reklamację.',
            copy: 'Skopiuj reklamację.',
            stopCards: 'Karty stop.'
        },

        status: {
            expired: 'Opóźnione'
        },

        external: {
            pageTitle: 'Reklamacje zewnętrzne',
            create: {
                pageTitle: 'Reklamacje zewnętrzne / Nowa reklamacja'
            },
            edit: {
                pageTitle: 'Reklamacje zewnętrzne / Edycja reklamacji'
            }
        },

        internal: {
            pageTitle: 'Reklamacje wewnętrzne',
            create: {
                pageTitle: 'Reklamacje wewnętrzne / Nowa reklamacja'
            },
            edit: {
                pageTitle: 'Reklamacje wewnętrzne / Edycja reklamacji',
                pageTitleWithNumber: 'Reklamacje wewnętrzne / Edycja reklamacji - {number}'
            },

            actions: {
                backToList: 'Powrót do listy',
                backToStopCards: 'Powrót do kart stop',
                save: 'Zapisz',
                confirm: 'Zapoznałem się'
            },

            details: {
                tabTitle: 'Szczegóły',
                title: 'Szczegóły reklamacji wewnętrznej',
                departmentLabel: 'Dział',
                productionSiteGroupLabel: 'Grupa stanowisk',
                productionProcessLabel: 'Proces produkcyjny',
                machineLabel: 'Maszyna',
                jobNumberLabel: 'Numer zlecenia',
                orderNumbersLabel: 'Numery zamówień',
                productTypeLabel: 'Rodzaj produktu',
                errorCodeGroupLabel: 'Grupa błędu',
                errorCodeLabel: 'Kod błędu',
                statusLabel: 'Status',
                statusUpdatePermissionHint: 'Zmiany statusu wymagają uprawnienia internal_complaints_update.',
                adjustmentValueLabel: 'Liczba poświęconych roboczogodzin (w min)',
                responsibleLabel: 'Osoby odpowiedzialne',
                proceedingWayLabel: 'Sposób postępowania',
                reprintQuestion: 'Czy chcesz uruchomić dodruk?',
                reprintYes: 'TAK',
                reprintNo: 'NIE',
                jobSearchLoading: 'Szukanie...',
                jobSearchTooShort: 'Wpisz conajmniej {min} znaki żeby wyszukać',
                jobSearchNotFound: 'Nie znaleziono zleceń'
            },

            attachments: {
                tabTitle: 'Załączniki',
                title: 'Załączniki',
                fileLabel: 'Pliki',
                placeholder: 'Wybierz pliki',
                uploadButton: 'Dodaj',
                noData: 'Nie dodano załączników.',
                defaultFileName: 'plik',
                fileSizeError: 'Plik {fileName} przekracza maksymalny rozmiar {maxSize} MB',
                headers: {
                    fileName: 'Nazwa pliku',
                    actions: 'Akcje'
                },
                downloadTooltip: 'Kliknij żeby pobrać',
                deleteTooltip: 'Usuń',
                deleteTitle: 'Usuwanie załącznika',
                deleteMessage: 'Czy na pewno chcesz usunąć załącznik: {fileName}?',
                deleteConfirmButton: 'Usuń'
            },

            causes: {
                tabTitle: 'Przyczyny',
                title: 'Przyczyny niezgodności',
                causeLabel: 'Przyczyna niezgodności',
                errorDescriptionLabel: 'Opis błędu',
                addNewError: 'Dodaj nowy',
                responsibleLabel: 'Osoby odpowiedzialne',
                responsibleSearchLoading: 'Szukanie...',
                responsibleSearchTooShort: 'Wpisz conajmniej 3 znaki żeby wyszukać',
                responsibleSearchNotFound: 'Nie znaleziono użytkowników'
            },

            dialogs: {
                addError: {
                    title: 'Dodawanie nowego błędu',
                    nameLabel: 'Nazwa błędu',
                    nameRequired: 'Proszę podać nazwę błędu.'
                }
            },

            recommendations: {
                tabTitle: 'Zalecenia',
                title: 'Zalecenia',
                measuresLabel: 'Środki korygujące niezgodność'
            },

            execution: {
                tabTitle: 'Wykonanie',
                title: 'Wykonanie',
                generateReportTooltip: 'Generuj raport'
            },

            defects: {
                buttons: {
                    selectJobDefects: 'Wybierz wadliwy montaż w zleceniu',
                    selectOrderDefects: 'Wybierz wadliwy element zamówienia'
                },
                headers: {
                    jobNumber: 'Numer zlecenia',
                    plateNumber: 'Numer montażu',
                    orderNumber: 'Numer zamówienia',
                    component: 'Komponenty',
                    amount: 'Nakład',
                    defectiveAmount: 'Wadliwy nakład',
                    defectiveAmountPercent: 'Wadliwy nakład w %'
                },
                jobDialog: {
                    title: 'Wybierz wadliwy montaż w zleceniu',
                    selectAllLabel: 'Zaznacz wszystkie montaże w zleceniu',
                    empty: 'Brak montaży do wyświetlenia',
                    platePrefix: 'Montaż',
                    rangeError: 'Podaj wartość w zakresie {min} - {max}',
                    headers: {
                        plateNumber: 'Numer montażu',
                        amount: 'Nakład',
                        defectiveAmount: 'Wadliwy nakład',
                        defectivePercent: 'Wadliwy nakład w %'
                    }
                },
                orderDialog: {
                    title: 'Wybierz wadliwy element zamówienia',
                    empty: 'Brak komponentów w wybranym zleceniu.',
                    orderNumberLabel: 'Numer zamówienia',
                    selectAllLabel: 'Zaznacz wszystkie komponenty w zamówieniu',
                    rangeError: 'Podaj wartość w zakresie {min} - {max}',
                    headers: {
                        components: 'Komponenty',
                        amount: 'Nakład',
                        defectiveAmount: 'Wadliwy nakład',
                        defectivePercent: 'Wadliwy nakład w %'
                    }
                },
                signaturesDialog: {
                    title: 'Wybierz składki dla komponentu',
                    empty: 'Brak składek do wyświetlenia',
                    signaturePrefix: 'Składka',
                    rangeError: 'Podaj wartość w zakresie {min} - {max}',
                    headers: {
                        signature: 'Składka',
                        amount: 'Nakład',
                        defectiveAmount: 'Wadliwy nakład',
                        defectivePercent: 'Wadliwy nakład w %'
                    }
                }
            },

            confirmDialog: {
                title: 'Potwierdzenie zapoznania się z reklamacją',
                message: 'Czy na pewno chcesz potwierdzić?'
            },

            validation: {
                departmentRequired: 'Dział jest wymagany.',
                jobNumberRequired: 'Numer zlecenia jest wymagany.',
                catcherRequired: 'Osoba wyłapująca błąd jest wymagana.',
                productDescriptionRequired: 'Opis reklamowanej części jest wymagany.',
                productDescriptionMinLength: 'Opis reklamowanej części musi mieć minimalnie 3 znaki.',
                productDescriptionMaxLength: `Opis reklamowanej części może mieć maksymalnie ${INTERNAL_COMPLAINT_PRODUCT_DESCRIPTION_MAX_LENGTH} znaków.`,
                responsiblePersonRequired: 'Conajmniej 1 osoba odpowiedzialna jest wymagana.',
                responsiblePersonMaxLength: 'Maksymalnie 10 osób odpowiedzialnych.',
                acceptedRequiresCausesTab:
                    'Nie można zmienić statusu na "Uznana" bez uzupełnienia wszystkich pól w zakładce "Przyczyny".',
                errorCodeGroupRequired: 'Grupa błędu jest wymagana.',
                errorCodeRequired: 'Kod błędu jest wymagany.',
                proceedingWayRequired: 'Sposób postępowania jest wymagany.',
                proceedingValueRequired: 'Ilość roboczogodzin w minutach jest wymagana.',
                proceedingValueMinValue: 'Ilość roboczogodzin musi być większa lub równa 0.'
            },

            errors: {
                fetchComplaint: 'Pobranie danych reklamacji wewnętrznej nie powiodło się.',
                create: 'Dodanie reklamacji wewnętrznej nie powiodło się.',
                update: 'Aktualizacja reklamacji wewnętrznej nie powiodła się.',
                fetchProductionDepartments: 'Pobranie działów nie powiodło się.',
                fetchProductionSiteGroups: 'Pobranie grup stanowisk nie powiodło się.',
                fetchProductionProcesses: 'Pobranie procesów produkcyjnych nie powiodło się.',
                fetchMachines: 'Pobranie maszyn nie powiodło się.',
                fetchReportItems: 'Wyszukiwanie zleceń nie powiodło się.',
                fetchUsers: 'Pobranie listy użytkowników nie powiodło się.',
                fetchErrorCodeGroups: 'Pobranie grup kodów błędu nie powiodło się.',
                fetchErrors: 'Pobranie błędów nie powiodło się.',
                fetchProceedingWays: 'Pobranie sposobów postępowania nie powiodło się.',
                fetchStatuses: 'Pobranie statusów nie powiodło się.',
                createAttachment: 'Dodanie załącznika nie powiodło się.',
                deleteAttachment: 'Usunięcie załącznika nie powiodło się.',
                createError: 'Dodanie opisu błędu nie powiodło się.',
                generateReportCard: 'Generowanie raportu nie powiodło się.'
            },

            notifications: {
                createSuccess: 'Reklamacja wewnętrzna została dodana.',
                updateSuccess: 'Reklamacja wewnętrzna została zaktualizowana.',
                errorCreateSuccess: 'Opis błędu został dodany.',
                attachmentCreateSuccess: 'Załącznik został dodany.',
                attachmentDeleteSuccess: 'Załącznik został usunięty.'
            }
        }
    },

    storageComplaints: {
        pageTitle: 'Zwroty',
        menuTitle: 'Zwroty',

        headers: {
            complaintNumber: 'Numer reklamacji',
            orderNumbers: 'Numer zamówienia',
            status: 'Status',
            createdAt: 'Data złożenia',
            actions: 'Akcje',
            plannedReturnDate: 'Planowana data zwrotu',
            packageNumber: 'Numer listu przewozowego'
        },

        filters: {
            packageNumber: 'Numer listu przewozowego',
            search: 'Szukaj'
        },

        actions: {
            addPackage: 'Dodaj list przewozowy',
            edit: 'Edytuj',
            save: 'Zapisz',
            cancel: 'Anuluj',
            close: 'Zamknij',
            confirm: 'Potwierdź'
        },

        dialogs: {
            createPackageTitle: 'Tworzenie listu przewozowego',
            editPackagesTitle: 'Edycja listów przewozowych',
            editPackageTitle: 'Edycja numeru listu przewozowego'
        },

        fields: {
            plannedReturnDate: 'Planowana data zwrotu',
            packageNumber: 'Numer listu przewozowego'
        },

        validations: {
            packageNumberRequired: 'Proszę podać numer listu przewozowego.',
            plannedReturnDateRequired: 'Proszę podać planowaną datę zwrotu.'
        },

        sentry: {
            addPackage: 'Dodaj list przewozowy.',
            edit: 'Edytuj listy przewozowe.',
            save: 'Zapisz.',
            cancel: 'Anuluj.',
            close: 'Zamknij.',
            confirm: 'Potwierdź.'
        }
    }
}

export default {
    messages,
    locale: 'pl'
}
